export default {
  title: "Company name",
  input: {
    title: {
      base: "{{action}} company name",
      action: {
        update: "Update",
        create: "Insert",
      },
    },
    name: {
      label: "Company name",
    },
  },
}
